import {
    AuthenticationProvider,
    ConsentProvider,
    I18nProvider,
    MonitoringErrorBoundary,
    NotificationsChildren,
    NotificationsProvider,
} from '@freelancelabs/components';
import { initLocales } from '@freelancelabs/shared';

import Setup from './Setup';

// @ts-expect-error -- le type de retour d'import.meta.glob ne correspond pas a la signature d'initLocales
initLocales(import.meta.glob('../../locales/*.json'));

const App = () => {
    return (
        <MonitoringErrorBoundary>
            <I18nProvider>
                <NotificationsProvider>
                    {/* Absent awsOauthDomain simply leaves SSO unmounted. */}
                    <AuthenticationProvider
                        awsUserPoolsId={import.meta.env.PUBLIC_AWS_USER_POOLS_ID}
                        awsUserPoolsWebClientId={import.meta.env.PUBLIC_AWS_USER_POOLS_WEB_CLIENT_ID}
                        awsCognitoRegion={import.meta.env.PUBLIC_AWS_COGNITO_REGION}
                        awsOauthDomain={import.meta.env.PUBLIC_AWS_OAUTH_DOMAIN}
                    >
                        <ConsentProvider>
                            <NotificationsChildren />
                            <Setup />
                        </ConsentProvider>
                    </AuthenticationProvider>
                </NotificationsProvider>
            </I18nProvider>
        </MonitoringErrorBoundary>
    );
};

export default App;
